

























































































import loginMixin from '../mixin/loginMixin';
import LoginBtnComp from './LoginBtnComp.vue';
import LoginTitleComp from './LoginTitleComp.vue';

import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { Form as ElForm } from 'element-ui';
import {
  sendEmailCodeApi,
  verifyEmailCodeApi,
  modifyPwdByEmailCodeApi,
} from '@/api/login';

@Component({
  name: 'registerFormComp',
  components: {
    LoginBtnComp,
    LoginTitleComp,
  },
})
export default class extends Mixins(loginMixin) {
  @Prop({ default: '' }) public email!: string;
  @Ref('verifyEmailForm') public formRef!: ElForm;

  get countDownNumStr() {
    return this.countDownNum + ' s';
  }

  public loading = false;
  public step = 1;
  public countDownNum = 60;
  public countDownFlag = false;
  public btnName: string = this.$t('login.nextStep') as string;
  public formData: any = {
    code: '',
    email: '',
    newPWD: '',
    confirmPWD: '',
    fkPlatformType: 'get_issue',
  }

  // 注册校验
  public formRules = {
    code: [
      { required: true, message: this.$t('login.verificationMsg'), trigger: 'blur' }
    ],
    email: [
      { required: true, message: this.$t('login.emailMsg'), trigger: 'blur' },
    ],
    newPWD: [
      { required: true, validator: this.validatePassword, trigger: 'blur'}
    ],
    confirmPWD: [
      { required: true, validator: this.validatePassword, trigger: 'blur' },
      { validator: this.validateConfirmPWD, trigger: 'blur' }
    ],
  };

  public mounted() {
    this.formData.email = this.email;
  }

  public validateConfirmPWD(rule: any, value: string, callback: (err?: any) => void) {
    if (this.formData.newPWD && this.formData.newPWD !== value) {
      callback(new Error(this.$t('login.validPwdMsg') + ''));
    }
    callback();
  }

  // 获取验证码
  public async getVerification() {
    if (!this.checkEmailEmpty()) {
      return;
    }
    const { data } = await sendEmailCodeApi(this.formData.email);
    if (data.code === '1003') {
      this.countDownFlag = true;
      this.setIntervalForVerify();
    }
  }
  // 验证码定时器：60s内不能重复获取
  public setIntervalForVerify() {
    const countDownTimer = setInterval(() => {
      if (this.countDownNum === 1) {
        clearInterval(countDownTimer);
        this.countDownFlag = false;
        this.countDownNum = 60
        return;
      }
      this.countDownNum += -1;
    }, 1000);
    // 组件销毁前清理定时器
    this.$once('hook:beforeDestroy', () => {
      clearInterval(countDownTimer);
    })
  }
  // 检查电话或区号是否为空
  public checkEmailEmpty() {
    if (!this.formData.email) {
      this.$message(this.$t('login.emailMsg') as string);
      return false;
    }
    return true;
  }
  // 下一步
  public handleNextStep() {
    if (this.step === 1) {
      this.formRef.validate(async (valid) => {
        if (valid) {
          try {
            await verifyEmailCodeApi(this.formData.email, this.formData.code);
            this.step += 1;
          } catch(err) {
            //
          }
        }
      })
    } else if (this.step === 2) {
      this.formRef.validate(async (valid) => {
        if (valid) {
          const formData = this.formData;
          delete formData.confirmPWD;
          const params: any = Object.assign({}, formData);
          params.requestUrlType = location.host;
          try {
            await modifyPwdByEmailCodeApi(params);
            this.step += 1;
            this.btnName = this.$t('login.returnLogin') as string;
          } catch(err) {
            //
          }
        }
      })
    } else {
      this.$emit('return-login', { newPWD: this.formData.newPWD});
    }
  }
  // 清除表单校验
  public clearValidate() {
    this.formRef.clearValidate();
  }
  // 重置表单
  public resetFormData() {
    this.formRef.resetFields();
  }
}
